// extracted by mini-css-extract-plugin
export default {"devBorder":"devBorder_devBorder__rgf2Z"};